import { render, staticRenderFns } from "./my-settings-modal.vue?vue&type=template&id=0ed41d2d&scoped=true&"
import script from "./my-settings-modal.vue?vue&type=script&lang=js&"
export * from "./my-settings-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed41d2d",
  null
  
)

export default component.exports